<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M8.69602 16.9567H3.3291M6.01238 19.6404V14.2734"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M3 11.824V8.53052C3 6.08836 4.52076 4.36328 6.96486 4.36328H17.0351C19.4724 4.36328 21 6.08836 21 8.53052V15.1176C21 17.5597 19.4792 19.2848 17.0351 19.2848H11.6225"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      opacity="0.4"
      d="M21 9.6582H3"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
